import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GeneralConfigurationSkeleton = () => (
  <Styles.Container>
    <Styles.Section>
      <Skeleton variant="text" width={200} height={24} />
      <Skeleton variant="text" width="80%" height={16} />
      <Skeleton variant="rounded" width="100%" height={56} />
    </Styles.Section>
    <Divider />
    <Styles.Section>
      <Skeleton variant="text" width={150} height={24} />
      <Skeleton variant="text" width="80%" height={16} />
      <Skeleton variant="rounded" width="100%" height={56} />
    </Styles.Section>
    <Divider />
    <Styles.Section>
      <Skeleton variant="text" width={180} height={24} />
      <Skeleton variant="text" width="80%" height={16} />
      <Skeleton variant="rounded" width="100%" height={56} />
    </Styles.Section>
  </Styles.Container>
)

export default GeneralConfigurationSkeleton
